
import { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";

interface StatsCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  className?: string;
  trend?: {
    value: number;
    label: string;
    isPositive?: boolean;
  };
}

export function StatsCard({ title, value, icon, className, trend }: StatsCardProps) {
  return (
    <Card className={`overflow-hidden bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all ${className}`}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-500">{title}</p>
            <h3 className="text-2xl font-bold mt-1.5 text-gray-800">{value}</h3>
            {trend && (
              <div className="flex items-center mt-2">
                <span 
                  className={`text-xs font-medium px-2 py-1 rounded-full
                    ${trend.isPositive ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`
                  }
                >
                  {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
                </span>
                <span className="text-xs text-gray-500 ml-2">{trend.label}</span>
              </div>
            )}
          </div>
          {icon && <div className="text-primary opacity-80">{icon}</div>}
        </div>
      </CardContent>
    </Card>
  );
}
